<template>
	<section class="user_form">

		<div class="field">
			<label for="field02">Фамилия</label>
			<input type="text" id="field02" v-model="model.last_name">
		</div>

		<div class="field">
			<label for="field01">Имя</label>
			<input type="text" id="field01" v-model="model.first_name">
		</div>

		<div class="field">
			<label for="field03">Отчество</label>
			<input type="text" id="field03" v-model="model.middle_name">
		</div>

		<div class="field">
			<label for="field04">Страна</label>
			<input type="text" id="field04" v-model="model.country">
		</div>

		<div class="field">
			<label for="field05">Район</label>
			<input type="text" id="field05" v-model="model.region">
		</div>

		<div class="field">
			<label for="field06">Город</label>
			<input type="text" id="field06" v-model="model.city">
		</div>

		<div class="field">
			<label for="field07">Область</label>
			<input type="text" id="field07" v-model="model.area">
		</div>

		<div class="field">
			<label for="field08">Улица</label>
			<input type="text" id="field08" v-model="model.street">
		</div>

		<div class="field">
			<label for="field09">Дом</label>
			<input type="text" id="field09" v-model="model.house">
		</div>

		<div class="field">
			<label for="field10">Квартира</label>
			<input type="text" id="field10" v-model="model.apartment">
		</div>

		<div class="field">
			<label for="field11">Описание</label>
			<input type="text" id="field11" v-model="model.description">
		</div>

		<div class="field">
			<label for="field12">День рождения</label>
			<input type="text" v-mask="'##-##-####'" id="field12" v-model="model.birthday">
		</div>

		<div class="field">
			<label for="admin">Администратор ?</label>
			<input type="checkbox" id="admin" v-model="model.admin">
		</div>

		<div class="field check_field">
			<label>Тип</label>
			<input class="type_check" type="checkbox" v-model="model.doctor_type" value="adult">
			<div class="forCheck">Взрослый</div>
			<input class="type_check" type="checkbox" v-model="model.doctor_type" value="childish">
			<div class="forCheck">Детский</div>
		</div>

		<div class="field">
			<label for="specialization">Специализации</label>
			<!--<select2 id="specialization" v-model="model.specializations_ids"-->
			<!--:multiple="true"-->
			<!--:options="specializations"-->
			<!--:label="'name'"-->
			<!--:id="'_id'">-->
			<!--</select2>-->

			<select id="specialization" v-model="model.specializations_ids" multiple>
				<option v-for="item in specializations" :value="item._id">{{item.name}}</option>
			</select>

		</div>

		<div class="field">
			<label for="field15">Номер телефона</label>
			<input type="number" id="field15" v-model="model.phone">
		</div>

		<div class="field">
			<label for="category">Категория</label>
			<input type="text" id="category" v-model="model.category">
		</div>

		<div class="field">
			<label for="experience">Стаж</label>
			<input type="text" id="experience" v-model="model.experience">
		</div>

		<div class="field">
			<label for="degree">Степень</label>
			<input type="text" id="degree" v-model="model.degree">
		</div>

		<div class="field">
			<label for="field14">Пол</label>
			<select id="field14" v-model="model.sex">
				<option value="male">Мужчина</option>
				<option value="female">Женщина</option>
			</select>
		</div>

		<div class="field">
			<label for="field13">Пароль</label>
			<input id="field13" type="text" v-model="model.password">
		</div>

	</section>
</template>

<script>
	import MultiSelect from 'vue-multiselect'

	export default {
		name: "UserForm",
		props: ['model'],
		components: {MultiSelect},
		mounted() {
			this.model.doctor_type = this.model.doctor_type || []
			this.$store.dispatch('specialization/all').then(list => {
				this.specializations = list
			})

			this.model.specializations_ids = this.model.specializations_ids || []
		},
		data() {
			return {
				specializations: []
			}
		}
	}
</script>

<style lang="scss">
	.user_form, .clinic_form, .worker_form, .specialization_form, .role_form {
		width: 700px;

		.field {
			margin-bottom: 5px;
			line-height: 20px;

			label {
				display: inline-block;
				width: 35%;
			}

			input {
				display: inline-block;
				border: 1px solid gray;
				height: 20px;
				padding-left: 5px;
			}
		}
	}

	.check_field {
		input {
			height: auto;
		}
	}

	select {
		width: 170px;
	}

	.forCheck {
		width: 70px;
		display: inline-block;
		line-height: 20px;
	}
</style>



// WEBPACK FOOTER //
// UserForm.vue?6d7e6a16